


// color
$('.color-select').on('click', function () {

    let color_id = $(this).data('color-id');

    if ($('#color_id_' + color_id).is(':checked')) {

        $(this).removeClass('bdc-light-blue-a700');
        $(this).find('i').css({
            opacity: 0
        });
        $('#color_id_' + color_id).prop('checked', false);
    } else {

        $(this).addClass('bdc-light-blue-a700');

        $(this).find('i').css({
            opacity: 1
        });
        $('#color_id_' + color_id).prop('checked', true);
    }

});



// google reCaptcha
grecaptcha.ready(function() {
    window.noCaptcha.render('login', function (token) {
        document.querySelector('#g-recaptcha-response').value = token;
    });
});


// etc

$('#submit_btn').prop('disabled', true);

$('#confirmation_check').on('click', function() {
    if ( $(this).prop('checked') === false ) {

        $('#submit_btn').prop('disabled', true);
    } else {
        $('#submit_btn').prop('disabled', false);
    }
});


let count_func = function() {
    let body_ele = $('#body').val();
    let target_ele = $('#body_count');
    target_ele.text(body_ele.length);
    body_ele.length > target_ele.data('text-max') ? target_ele.addClass('text-danger').removeClass('text-secondary') : target_ele.addClass('text-secondary').removeClass('text-danger');

};

count_func();

$("#body").on("keydown keyup keypress change", function () {
    count_func();
});


$('#submit_btn').on('click', function () {
    confirmed('info', '入力した内容でオファー登録をしますか', '登録する');
}).prop('disabled', true);

